import Button from '@Shared/Ui/Button';

import styles from './style.module.scss';
import { assetUrl } from '@Shared/Helpers/Utilities';

function VersionUpdated() {
    return (
        <div className={styles.container}>
            <img
                className={styles.logo}
                src={assetUrl('/assets/images/svg/logo.svg')}
                alt='logo'
            />
            <label className={styles.title}>{__('components.version_updated.title')}</label>
            <label className={styles.description}>
                {__('components.version_updated.description')}
            </label>

            <Button
                className={styles.button}
                onClick={() => window.location.reload()}
                name={__('Refresh')}
            />

            <div className={styles.wave} />
        </div>
    );
}

export default VersionUpdated;
